export const callHistoryQueryKeys = {
  ringList: ({ fromDate, toDate, requestId, operatorId, companyId, phone }) => [
    'ringList',
    fromDate,
    toDate,
    requestId,
    operatorId,
    companyId,
    phone,
  ],

  callRecord: (recordId) => ['callRecord', recordId],
  operators: () => ['operators'],
};
